import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  deleteArqueacao,
  findArqueacao,
  recordFiltering,
} from '~/store/modules/arqueacao/actions';

import Form from './form';

export default function Arqueacao() {
  const data = useSelector((state) => state.arqueacao);

  const header = useMemo(
    () => [
      {
        id: 'poco_descricao',
        label: 'Unidade',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'arqu_descricao',
        label: 'Descrição',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'arqu_altura_maxima',
        label: 'Altura Máx',
        filter: {
          type: 'number',
        },
      },
      {
        id: 'arqu_volume_maximo',
        label: 'Volume Máx',
        filter: {
          type: 'number',
        },
      },
      {
        id: 'arqu_unidade_medida',
        label: 'Unid. Med.',
        align: 'center',
        filter: {
          type: 'select',
          options: [
            { label: 'CM', value: 'CM' },
            { label: 'MM', value: 'MM' },
          ],
        },
      },
    ],
    []
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="arqu_codigo ASC"
      fixed
      read={recordFiltering}
      find={findArqueacao}
      remove={deleteArqueacao}
      redux={data}
      header={header}
      detach="poco_descricao"
      keys={['arqu_codigo', 'poco_codigo']}
      form={Form}
      view="VW_ARQUEACAO"
      reportTitle="Cadastro de Arqueação"
    />
  );
}
